import type { Translatable } from "app/pages/sales-intelligence/types";

export const DROPDOWN_ID = "signal-templates-dd";

export const UNKNOWN_SIGNAL_TRANSLATABLE: Readonly<Translatable> = {
    key: "Unknown signal",
};

export const DROPDOWN_WIDTH = 320;

export const TOOLTIP_WIDTH = 230;
